(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initialize(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const q = (selector) => root.querySelector(selector);
      const all = (selector) => [...root.querySelectorAll(selector)];
      const form = q('.tvp-form');
      const selector = q('[data-variant-select]');
      const templates = all('template[data-variant]');
      const quantity = q('[data-quantity]');
      const buy = q('[data-buy]');
      const slides = all('[data-slide]');
      const thumbs = all('[data-thumb]');
      let current = 0;
      function showImage(index, scroll = false) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== current;
        });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === current)));
        if (q('[data-count]')) q('[data-count]').textContent = String(current + 1);
        if (scroll && thumbs[current])
          thumbs[current].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showImage(i, true)));
      q('[data-prev]')?.addEventListener('click', () => showImage(current - 1, true));
      q('[data-next]')?.addEventListener('click', () => showImage(current + 1, true));
      q('.tvp-gallery')?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          showImage(current + (event.key === 'ArrowLeft' ? -1 : 1), true);
        }
      });
      let start = null;
      q('.tvp-gallery')?.addEventListener(
        'touchstart',
        (event) => {
          start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        },
        { passive: true },
      );
      q('.tvp-gallery')?.addEventListener(
        'touchend',
        (event) => {
          if (!start) return;
          const dx = event.changedTouches[0].clientX - start.x;
          const dy = event.changedTouches[0].clientY - start.y;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy))
            showImage(current + (dx < 0 ? 1 : -1), true);
          start = null;
        },
        { passive: true },
      );
      function normalizeQuantity() {
        const min = Number(quantity.min) || 1;
        const step = Number(quantity.step) || 1;
        const max = quantity.max ? Number(quantity.max) : Infinity;
        let value = Number(quantity.value);
        if (!Number.isFinite(value)) value = min;
        value = Math.max(min, min + Math.round((value - min) / step) * step);
        if (value > max) value = min + Math.floor((max - min) / step) * step;
        quantity.value = String(Math.max(min, value));
        q('[data-minus]').disabled = value <= min;
        q('[data-plus]').disabled = value + step > max;
      }
      q('[data-minus]').addEventListener('click', () => {
        quantity.value = String(Number(quantity.value) - Number(quantity.step || 1));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
      q('[data-plus]').addEventListener('click', () => {
        quantity.value = String(Number(quantity.value) + Number(quantity.step || 1));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
      quantity.addEventListener('change', normalizeQuantity);
      function syncOrderProperties(selected) {
        const holder = q('[data-properties]');
        const source = selected?.content.querySelector('[data-properties-content]');
        if (!holder || !source) return;
        // All selected-variant properties must be real inputs INSIDE the form.
        holder.replaceChildren(...source.cloneNode(true).childNodes);
      }
      function updateVariant(updateUrl = false) {
        const selected = templates.find((template) => template.dataset.variant === selector.value);
        if (!selected) {
          buy.disabled = true;
          return;
        }
        const data = selected.dataset;
        q('[data-summary]').replaceChildren(
          ...selected.content.querySelector('[data-summary-content]').cloneNode(true).childNodes,
        );
        syncOrderProperties(selected);
        const available = data.available === 'true';
        buy.disabled = !available;
        buy.textContent = available ? data.cta : root.dataset.soldOut;
        if (q('[data-express]')) q('[data-express]').hidden = !available;
        if (root.dataset.preorder !== 'true')
          q('[data-status]').textContent = available ? root.dataset.inStock : root.dataset.soldOut;
        const wrap = q('[data-payment-options]');
        const choices = templates.filter(
          (template) =>
            template.dataset.group === data.group && template.dataset.mode !== 'regular',
        );
        wrap.replaceChildren();
        choices.forEach((template) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'tvp-card';
          button.dataset.paymentVariant = template.dataset.variant;
          button.setAttribute('aria-pressed', String(template === selected));
          button.disabled = template.dataset.available !== 'true';
          [...template.content.children]
            .filter((child) => !child.matches('[data-summary-content],[data-properties-content]'))
            .forEach((child) => button.appendChild(child.cloneNode(true)));
          button.addEventListener('click', () => {
            selector.value = template.dataset.variant;
            selector.dispatchEvent(new Event('change', { bubbles: true }));
            q(`[data-payment-variant="${template.dataset.variant}"]`)?.focus({
              preventScroll: true,
            });
          });
          wrap.appendChild(button);
        });
        wrap.hidden = choices.length === 0;
        const selectWrap = q('[data-simple-payment]');
        if (selectWrap)
          selectWrap.hidden = choices.length === templates.length && choices.length > 0;
        quantity.min = data.min;
        quantity.step = data.step;
        if (data.max) quantity.max = data.max;
        else quantity.removeAttribute('max');
        normalizeQuantity();
        const imageIndex = slides.findIndex((slide) => slide.dataset.slide === data.image);
        if (imageIndex >= 0) showImage(imageIndex);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', data.variant);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }
      selector.addEventListener('change', () => updateVariant(true));
      form.addEventListener('submit', (event) => {
        normalizeQuantity();
        const selected = templates.find((template) => template.dataset.variant === selector.value);
        if (!selected || selected.dataset.available !== 'true') {
          event.preventDefault();
          return;
        }
        syncOrderProperties(selected);
      }, true);
      updateVariant();
      const description = q('[data-description]');
      const packagePanel = q('[data-panel="package"]');
      const specTarget = q('[data-extra-specs]');
      description
        .querySelectorAll('[data-toyvix-content="package"]')
        .forEach((node) => packagePanel.appendChild(node));
      description
        .querySelectorAll('[data-toyvix-content="specifications"]')
        .forEach((node) => specTarget.appendChild(node));
      const packageTab = q('[data-tab="package"]');
      packageTab.hidden = !packagePanel.children.length;
      const tabs = all('[data-tab]').filter((tab) => !tab.hidden);
      const panels = all('[data-panel]');
      function activateTab(name, focus = false) {
        tabs.forEach((tab) => {
          const active = tab.dataset.tab === name;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.panel !== name;
        });
      }
      panels.forEach((panel) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute(
          'aria-labelledby',
          `Tab-${panel.dataset.panel}-${root.id.replace('ToyvixProduct-', '')}`,
        );
        panel.tabIndex = 0;
      });
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activateTab(tab.dataset.tab));
        tab.addEventListener('keydown', (event) => {
          let target = null;
          if (event.key === 'ArrowRight') target = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== null) {
            event.preventDefault();
            activateTab(tabs[target].dataset.tab, true);
          }
        });
      });
      q('[data-tabs]').hidden = false;
      activateTab('description');
      q('[data-open-shipping]')?.addEventListener('click', () => {
        activateTab('shipping');
      });
      const preorderDialog = q('[data-preorder-dialog]');
      const preorderLauncher = q('[data-open-preorder-dialog]');
      if (preorderDialog && preorderLauncher) {
        preorderLauncher.addEventListener('click', () => {
          if (!preorderDialog.open) preorderDialog.showModal();
          q('[data-preorder-dialog-heading]')?.focus();
        });
        q('[data-close-preorder-dialog]')?.addEventListener('click', () => preorderDialog.close());
        preorderDialog.addEventListener('close', () => preorderLauncher.focus());
        preorderDialog.addEventListener('click', (event) => {
          if (event.target === preorderDialog) preorderDialog.close();
        });
      }
    }
    function scan(scope = document) {
      if (scope.matches?.('[data-tvp]')) initialize(scope);
      scope.querySelectorAll('[data-tvp]').forEach(initialize);
    }
    if (document.readyState === 'loading')
      document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
    else scan();
    if (!window.toyvixProductV2Listener) {
      document.addEventListener('shopify:section:load', (event) => scan(event.target));
      window.toyvixProductV2Listener = true;
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
